import React from 'react';
import { FormText, TextArea, Fieldset, FormSelect } from '~/components/FormControl';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';

function BasicInfo({ asyncApiCall }) {
    const { adventureCategories } = useSelector((state) => state.heroSaga.boon);

    return (
        <Fieldset
            className={'px-2'}
            fieldsetStyle={{ flexGrow: 1 }}
        >
            <Fieldset.Legend>Basic Info:</Fieldset.Legend>
            <FormText
                name="name"
                asyncApiCall={asyncApiCall}
                sm={12}
            />
            <TextArea
                name="description"
                rows={4}
                sm={12}
                className="mt-3"
            />
            <FormSelect
                as={Col}
                sm={12}
                name="adventureCategoryId"
                options={adventureCategories}
                className="mt-3"
                label="Adventure"
            />
        </Fieldset>
    );
}

BasicInfo.propTypes = {
    asyncApiCall: PropTypes.func.isRequired,
};
export default BasicInfo;
